// ExportCVPDialog.tsx — Export current project as a native .cvp file

import DialogBase from './DialogBase';
import { useShallowStore } from '../store/useStore';
import { exportProjectCVP } from '../utils/cvpFormat';

export default function ExportCVPDialog() {
  const project = useShallowStore(s => s.project);

  return (
    <DialogBase
      title="Export Project (.cvp)"
      okLabel="Export"
      onOk={() => project && exportProjectCVP(project)}
    >
      {project ? (
        <>
          <p className="dialog-info">
            Exporting <strong>{project.name}</strong> as a native CV project file.
          </p>
          <p className="dialog-info">
            {project.panels.length} panel(s) · settings · site plan
          </p>
          <p className="dialog-info">
            The .cvp file is a complete, lossless archive. Re-import with
            File → Import CV File to restore the full project.
          </p>
        </>
      ) : (
        <p className="dialog-warning">No project open. Please open or create a project first.</p>
      )}
    </DialogBase>
  );
}
